import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import mapStateToFormProps from '../../utils/mapStateToFormProps';
import Dropdown from 'components/connectedForm/Dropdown';
import componentQuery from '../../utils/componentQuery';
import btnStyles from '../../styles/partials/_button.css';
import { serviceActions } from '../../state/modules/service';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import CheckPopUpBlockerFunction from '../../utils/CheckPopUpBlockerFunction';
import EmailEditor from '../report/EmailEditor';
import { default as Form } from '../connectedForm';
import systemPrintersQuery from 'graphql/queries/system/SystemSystemPrinterListQuery.graphql';
import DocumentConfig from '../../graphql/entities/sales/DocumentConfig';
import { ReportTemplate } from '../../graphql/entities';
import QueryDropdown from '../connectedForm/QueryDropdown';
import * as withContainer from '../../graphql/containers';
import getIn from '../connectedForm/utils/getIn';
import { emailFromEntity } from '../../utils/EmailUtils';
import getValue from '../connectedForm/utils/getValue';
import { getAvailableReportOutputTypes } from '../../utils/getAvailableReportOutputTypes';
import { getDefaultOutputType } from '../../utils/getDefaultOutputType';
import getClientMutationId from '../../utils/getClientMutationId';
import ToggleInput from '../connectedForm/ToggleInput/ToggleInput';
import { AlertType } from '../../graphql/schema/p4types';
import { isFunction } from '../react-data-grid/utils';
import { Analytics } from '../../mixpanel';

/**
 * @deprecated Do not use this component for new code.
 * Either DocumentModal2 (With an 'onPrintClick' prop) or a manual implementation is preferred. (See AllocationAuditCriteriaModal for an example).
 */
class GenericReportModal extends Component {
  constructor(props) {
    super(props);

    this.styles = {};
    Object.assign(this.styles, btnStyles);

    this.state = {
      templates: props.templates,
      template: null,
      outputType: null,
      systemPrinters: [],
      systemPrinterId: null,
      emailConfig: this.props.emailConfig || null,
      ...props.defaultState,
    };

    this.outputOptional = this.props.outputOptional ? this.props.outputOptional : false;

    this.onClose = this.onClose.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.print = this.print.bind(this);
    this.onChange = this.onChange.bind(this);
    this.renderPrinterSelection = this.renderPrinterSelection.bind(this);
    this.setDefaultState = this.setDefaultState.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const prevDefault = getIn(this.props, `data.data.${this.props.documentName}`);
    const nextDefault = getIn(nextProps, `data.data.${this.props.documentName}`);

    if (
      prevDefault !== nextDefault ||
      (!this.state.template && nextProps.templates != null) ||
      this.props.values?.customer !== nextProps.values?.customer ||
      this.props?.additionalDefaultState !== nextProps?.additionalDefaultState
    ) {
      this.setDefaultState(nextProps, nextDefault);
    }
  }

  componentDidMount() {
    componentQuery(systemPrintersQuery, null, true, null).then(({ response: data }) => {
      const systemPrinters = [];
      for (const systemPrinter of data.list.edges) {
        systemPrinters.push(systemPrinter.node);
      }

      this.setState({
        systemPrinters,
      });
    });

    //documentName required. (If customer configurable, also recipientDocumentDefault).
    if (!this.props.documentName) {
      console.warn('Unable to load report defaults. Document name undefined.');
    } else {
      this.setDefaultState(this.props, getIn(this.props, `data.data.${this.props.documentName}`));
    }
  }

  onClose() {
    this.props.onClose();
  }

  onComplete(shouldPrint, job) {
    if (job.properties.reportFile) {
      const newTab = CheckPopUpBlockerFunction(
        this.props,
        `/api/resources/report/${job.properties.reportFile}`,
        '_blank'
      );
      if (newTab && shouldPrint) {
        newTab.print();
      }
    }
  }

  print() {
    if (!this.state.template) {
      this.props.dispatch(serviceActions.genericAlert('Error', 'Please select a template', AlertType.Warning));
      return;
    }

    if (!this.outputOptional && !this.state.outputType) {
      this.props.dispatch(serviceActions.genericAlert('Error', 'Please select an output type', AlertType.Warning));
      return;
    }

    const input = this.props.input(this.state, this.props);
    input.clientMutationId = getClientMutationId();

    let outputType = this.state.outputType || null;
    if (outputType && outputType.value) {
      outputType = outputType.value;
    }

    input.reportParameters = Object.assign(input.reportParameters || {}, {
      template: this.state.template.node || this.state.template,
      outputType: outputType,
    });

    if (this.props.allowOverride) {
      input.reportParameters.overrideOutput = this.state.overrideOutput;
      input.reportParameters.overrideTemplate = this.state.overrideTemplate;
    }

    if (outputType) {
      if (outputType === 'SYSTEM_PRINTER' && this.state.systemPrinterId) {
        input.reportParameters.printerId = this.state.systemPrinterId;
      }

      if (outputType === 'EMAIL' && this.state.emailConfig) {
        input.reportParameters.emailToList = this.state.emailConfig.emailTo.map((email) => email.email).toString();
        input.reportParameters.emailSubject = this.state.emailConfig.emailSubject;
      }
    }

    const shouldPrint = outputType && (outputType === 'LOCAL_PRINTER' || outputType === 'SYSTEM_PRINTER');

    createBackgroundJob(
      this.props.mutation,
      input,
      this.props,
      null,
      this.props.printMessage ? this.props.printMessage : 'Report Printed',
      this.onComplete.bind(this, shouldPrint)
    );
    this.onClose();

    // Track user print options
    Analytics.track('Report printed', {
      documentType: this.props.title,
      outputType: this.state.outputType?.value,
      template: this.state.template?.node?.name,
      overrideTemplate: this.state.overrideTemplate,
      overrideOutput: this.state.overrideOutput,
      showSummary: this.state.showSummary,
      printIndividually: this.state.printIndividually,
      printContiguous: this.state.printContiguous,
    });
  }

  onChange(field, el, callback) {
    let value = el;
    if (value && typeof value !== 'string' && value.target) {
      value = el.target.value;
      if (el.target.type === 'checkbox') {
        value = value !== 'true';
      }
    }

    if (isFunction(callback)) {
      this.setState(
        {
          [field]: value,
        },
        callback
      );
    } else {
      this.setState({
        [field]: value,
      });
    }
  }

  setDefaultState(props, documentDefault) {
    const customer = getIn(props, 'values.customer');
    documentDefault = documentDefault || {};

    if (customer && props.useCustomerDefaults && props.entity) {
      const customerDefault = getIn(customer, this.props.recipientDocumentDefault);
      const tempDD = customerDefault[this.props.documentName];
      const recipientContacts = customer.contacts
        ? customer.contacts.filter((contact) => {
            return contact[getIn(props.entity, 'configuration.receiveFlag')];
          })
        : [];

      documentDefault = { ...tempDD };
      if (customerDefault.documentRequired) documentDefault.documentRequired = customerDefault.documentRequired;
      if (customerDefault.output) documentDefault.output = customerDefault.output;
      if (customerDefault.systemPrinterId) documentDefault.systemPrinterId = customerDefault.systemPrinterId;
      if (customerDefault.layout) documentDefault.layout = customerDefault.layout;

      //Fetch email list from customer record.
      documentDefault.emailList = emailFromEntity(
        props.entity,
        getIn(props, 'values.customerContact'),
        recipientContacts
      ).map((contact) => ({ label: contact.name || contact.email, value: contact.email }));
    }

    const layout = documentDefault.layout
      ? documentDefault.layout
      : Array.isArray(props.templates)
      ? props.templates.find((el) => el !== undefined)
      : null;
    const template = this.props.templateFilters
      ? layout
      : layout && layout.node
      ? { node: { ...layout.node } }
      : { node: { ...layout } };

    this.setState({
      outputType: documentDefault.output || getDefaultOutputType(template?.node?.reportTemplateFormat),
      systemPrinterId: documentDefault.systemPrinterId,
      template,
      emailConfig: {
        emailSubject: documentDefault.subject,
        emailTo: documentDefault.emailList || props.emailConfig?.emailTo || [],
        emailCc: [],
      },
      message: documentDefault.body ? documentDefault.body : '',
      ...props?.additionalDefaultState,
    });
  }

  renderPrinterSelection() {
    if (this.state.outputType && this.state.outputType.value === 'SYSTEM_PRINTER') {
      return (
        <Form.Row>
          <Form.Fieldset classNames="col12">
            <Dropdown
              options={this.state.systemPrinters}
              component={Dropdown}
              label="System Printer"
              onChange={(value) => {
                this.setState({
                  systemPrinterId: value.id,
                });
              }}
              value={this.state.systemPrinterId}
              valueKey="id"
              labelKey="printerName"
            />
          </Form.Fieldset>
        </Form.Row>
      );
    }

    return null;
  }

  render() {
    const templateDropdown = this.props.templateFilters ? (
      <QueryDropdown
        {...ReportTemplate.dropdown}
        predefinedFilters={this.props.templateFilters}
        label="Template"
        onChange={(e) => {
          this.onChange('template', e, () => {
            this.setState({
              outputType: getDefaultOutputType(this.state.template?.node?.reportTemplateFormat),
            });
          });
        }}
        value={this.state.template}
        inputCols={8 / 12}
        labelCols={4 / 12}
      />
    ) : (
      <Dropdown
        options={this.props.templates}
        valueKey="node.id"
        labelKey="node.name"
        onChange={(e) => {
          this.onChange('template', e, () => {
            this.setState({
              outputType: getDefaultOutputType(this.state.template?.node?.reportTemplateFormat),
            });
          });
        }}
        label="Template"
        value={this.state.template}
        inputCols={8 / 12}
        labelCols={4 / 12}
      />
    );

    let printAction = 'Go';

    if (this.state.outputType?.value) {
      switch (this.state.outputType.value) {
        case 'PDF':
        case 'DOCX':
        case 'XLSX':
        case 'CSV':
          printAction = 'Download';
          break;
        case 'EMAIL':
          printAction = 'Send';
          break;
        case 'LOCAL_PRINTER':
        case 'SYSTEM_PRINTER':
          printAction = 'Print';
          break;
        default:
          printAction = 'Go';
      }
    }

    return (
      <div className={this.styles.contentContainer}>
        <div className={this.styles.hdrTitleContainer}>
          <h2 className={this.styles.hdrTitle}>{this.props.title}</h2>

          <div className={this.styles.actionContainer}>
            <button
              className={this.styles.btnSecondary}
              onClick={(e) => {
                e.preventDefault();
                this.onClose();
              }}
            >
              Skip
            </button>
            <button
              className={this.styles.btnSuccess}
              onClick={(e) => {
                e.preventDefault();
                this.print();
              }}
            >
              {printAction}
            </button>
          </div>
        </div>
        {this.props.allowOverride ? (
          <Form.Fieldset cols={1 / 3}>
            <ToggleInput
              dataid="overrideTemplate"
              label="Override Template"
              value={this.state.overrideTemplate}
              onChange={(value) => this.setState({ overrideTemplate: getValue(value) })}
              labelCols={4 / 5}
              inputCols={1 / 5}
              hint={'If not set, customer defaults will be used.'}
            />
          </Form.Fieldset>
        ) : null}
        {!this.props.allowOverride || (this.props.allowOverride && this.state.overrideTemplate)
          ? templateDropdown
          : null}
        {this.props.allowOverride ? (
          <Form.Fieldset cols={1 / 3}>
            <ToggleInput
              dataid="overrideOutput"
              label="Override Output"
              value={this.state.overrideOutput}
              onChange={(value) => this.setState({ overrideOutput: getValue(value) })}
              labelCols={4 / 5}
              inputCols={1 / 5}
              hint={'If not set, customer defaults will be used.'}
            />
          </Form.Fieldset>
        ) : null}
        {!this.props.allowOverride || (this.props.allowOverride && this.state.overrideOutput) ? (
          <Dropdown
            dataid="outputType"
            options={
              this.props.outputSelection
                ? this.props.outputSelection
                : getAvailableReportOutputTypes(this.state.template?.node?.reportTemplateFormat)
            }
            label="Output"
            onChange={(value) => {
              this.onChange('outputType', value);
            }}
            value={this.state.outputType}
            valueKey="value"
            labelKey="label"
            clearable={false}
            inputCols={8 / 12}
            labelCols={4 / 12}
          />
        ) : null}
        {this.renderPrinterSelection()}
        {React.Children.map(this.props.children, (child) => {
          return React.cloneElement(child, {
            onChange: this.onChange.bind(null, child.props.dataid),
            value: this.state[child.props.dataid],
          });
        })}
        {this.state.outputType && this.state.outputType.value === 'EMAIL' ? (
          <EmailEditor
            {...this.state.emailConfig}
            allowEmailTo={this.props.allowEmailTo ? this.props.allowEmailTo : false}
            emailToReadOnly={this.props.emailToReadOnly !== undefined ? this.props.emailToReadOnly : true}
            onUpdate={(value) => this.onChange('emailConfig', value)}
          />
        ) : null}
      </div>
    );
  }
}

export default compose(connect(mapStateToFormProps), withContainer.query(DocumentConfig.instance))(GenericReportModal);
